import { MenuList } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { getSearchParams, initSearch, stopSearch } from "../../../Tools/Requests";
import Params from "../../../Sections/ElementsSections/Params/Params";
import clsx from "clsx";
import dialogStyles from "./dialogStyles.module.css";
import SplitterLocal from "../../../Tools/Splitter";
import VirtualList from "../../../Tools/VirtualList/VirtualList";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { Prefixes } from "../../../Tools/ProjectX";

interface Props {
  Module: Prefixes;
  ObjType?: string;
  GroupId: string;
  returnFunc?: (id: string) => void;
}

// Входные данные:
// GroupID: ID выбранной таблицы(number)
// Module: название модуля родительского компонента(string)
// ObjType: тип Объекта родительского компонента(number)
// return: функция(хук) для получения результата поиска(setState())
export default function Search(props: Props) {
  const { Module: module, ObjType: objType, GroupId: groupId, returnFunc } = props;

  const [records, setRecords] = useState<Array<{ text: string; id: string }>>([]);
  const [data, setData] = useState<{ [key: string]: any }>();
  const [startLoading, setStartLoading] = useState<boolean | undefined>();
  const [listSelected, setListSelected] = useState<{ text?: string; id?: string }>();

  const selected = useRef<{ text?: string; id?: string }>(undefined);
  const load = useRef(false);

  const index = useRef<string>("0");
  const currentStep = useRef(0);
  const step = 20;

  // функция формирования объекта для параметров
  async function getData() {
    const json: { Items: Array<{ JSONType?: string; EditStyle?: string }> } = await getSearchParams(groupId, module);
    if (json.Items[0].JSONType === "ParamItems") {
      json.Items.shift();
    }
    json.Items.forEach((item) => {
      item = { ...item, EditStyle: "16" };
    });
    return { ...json };
  }

  // хук для обновления data при изменении props
  useEffect(() => {
    getData().then((res) => {
      setData(res);
    });
  }, [props]);

  useEffect(() => {
    if (startLoading) {
      const result: Array<{ text: string; id: string }> = [];
      load.current = true;
      loading(result);
    } else {
      load.current = false;
    }
  }, [startLoading]);

  const onClickSearch = async () => {
    setStartLoading(!startLoading);
  };

  const loading = async (result: Array<{ text: string; id: string }>) => {
    while (load.current) {
      const json = await initSearch(module, data?.Path, index.current, objType);
      if (!json.Result) {
        load.current = false;
        break;
      }
      index.current = json.Index || "0";
      result.push({ text: json.Name || "", id: json.ObjRef || "" });

      currentStep.current = currentStep.current + 1;
      if (currentStep.current === step) {
        currentStep.current = 0;
        setRecords([...result]);
      }
    }
    stopSearch(module);
    index.current = "0";
    currentStep.current = 0;
    setRecords([...result]);
    setStartLoading(false);
  };

  const onApplySearch = async () => {
    if (selected.current?.id) returnFunc?.(selected.current.id);
  };

  return (
    <>
      {/* {Основной контейнер} */}
      <div className={clsx(dialogStyles.mainDialogBlock, dialogStyles.dialogSubBorder)}>
        {/* {контейнер с Параметрами} */}
        <SplitterLocal
          style={{ width: "100%", height: "100%" }}
          primaryIndex={0}
          sizeSecondary={"30%"}
          hideButtons={true}
          orientation="vertical"
        >
          <Params
            Module={module}
            GroupID={groupId}
            reqCommand={"GetSearchParams"}
            SectionID={objType}
            id={objType}
            data={data}
            NoHistory={true}
            NoTitle={true}
          />
          <div className={clsx(dialogStyles.mainDialogBlock)}>
            <button className={clsx(dialogStyles.dialogSearchButton)} onClick={onClickSearch}>
              {startLoading ? "Остановить" : "Искать"}

              <AutorenewIcon
                className={clsx(
                  dialogStyles.dialogSearchButton,
                  startLoading ? dialogStyles.dialogRotation : dialogStyles.dialogHidden,
                )}
              />
            </button>
            <div className={clsx(dialogStyles.fullDialogFlexContainer, dialogStyles.dialogSubBorder)}>
              <MenuList
                style={{
                  height: "100%",
                  width: "100%",
                  outline: "none",
                }}
                onKeyDown={(ev: any) => {
                  if (ev.code === "Enter") {
                  }
                }}
              >
                <VirtualList
                  items={records}
                  selected={listSelected}
                  onClick={(data) => {
                    selected.current = { text: data?.text, id: data?.id };
                    setListSelected(selected.current);
                  }}
                  onDoubleClick={(data) => {
                    selected.current = { text: data?.text, id: data?.id };
                    setListSelected(selected.current);

                    setTimeout(() => {
                      onApplySearch();
                    });
                  }}
                  onKeyDown={(data, e) => {
                    if (e.key === "Enter") {
                      selected.current = { text: data?.text, id: data?.id };
                      setListSelected(selected.current);

                      setTimeout(() => {
                        onApplySearch();
                      });
                    }
                  }}
                />
              </MenuList>
            </div>
          </div>
        </SplitterLocal>
      </div>
    </>
  );
}
